export const OPEN_PRELOADER = 'OPEN_PRELOADER';
export const CLOSE_PRELOADER = 'CLOSE_PRELOADER';
